// extracted by mini-css-extract-plugin
export var tbdBlock = "styles-module--tbd-block--fuOz9";
export var tbdBlockContainer = "styles-module--tbd-block-Container--OyDIO";
export var tbdBlockContainerText = "styles-module--tbd-block-Container-text--NY1i6";
export var tbdBlockContainerTextSpan = "styles-module--tbd-block-Container-text-span--k9FMX";
export var tbdBlockContainerLinkButton = "styles-module--tbd-block-Container-linkButton--zUbxb";
export var tbdBlockContainerLinkButtonLink = "styles-module--tbd-block-Container-linkButton-link--v2opG";